import { Helmet } from "react-helmet-async";
import { BreadcrumbsJsonLd } from "@/components/seo/BreadcrumbsJsonLd";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { APP_URL, CANONICAL_ORIGIN, canonicalUrl } from "@/lib/app-config";

const buildContactJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "@id": canonicalUrl("/contact"),
  name: "Contact Elara Health",
  description: "Get in touch with Elara Health for questions about therapies or support.",
  url: canonicalUrl("/contact"),
  inLanguage: "en-US",
  mainEntityOfPage: { "@id": canonicalUrl("/contact") },
  isPartOf: { "@id": `${CANONICAL_ORIGIN}/#website` },
  publisher: { "@id": `${CANONICAL_ORIGIN}/#organization` },
  mainEntity: {
    "@type": "Organization",
    "@id": `${CANONICAL_ORIGIN}/#organization`,
    name: "Elara Health",
    email: "support@elarahealth.life",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Long Island",
      addressRegion: "NY",
      addressCountry: "US",
    },
  },
});

const Contact = () => (
  <>
    <Helmet>
      <title>Contact Elara Health | Get in Touch</title>
      <meta name="description" content="Have questions about Elara Health therapies or need support? Contact our team. We typically respond within 1–2 business days." />
      <link rel="canonical" href={canonicalUrl("/contact")} />
      <script type="application/ld+json">{JSON.stringify(buildContactJsonLd())}</script>
    </Helmet>
    <BreadcrumbsJsonLd items={[{ name: "Contact" }]} />
    <Navbar />
    <main className="min-h-screen pt-24 pb-16">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="font-display text-4xl md:text-5xl text-foreground mb-6">Contact Us</h1>
        <div className="prose prose-lg text-muted-foreground space-y-4">
          <p>Have questions about our therapies or need support? We're here to help.</p>
          <ul className="list-none space-y-2 pl-0">
            <li><strong className="text-foreground">Email:</strong>{" "}
              <a href="mailto:support@elarahealth.life" className="text-champagne hover:underline">support@elarahealth.life</a>
            </li>
            <li><strong className="text-foreground">Location:</strong> Long Island, New York</li>
          </ul>
          <p className="text-sm">We typically respond within 1–2 business days.</p>
        </div>
      </div>
    </main>
    <Footer />
  </>
);

export default Contact;
